import { render, staticRenderFns } from "./AddStep2.vue?vue&type=template&id=c8334b34&scoped=true&"
import script from "./AddStep2.vue?vue&type=script&lang=js&"
export * from "./AddStep2.vue?vue&type=script&lang=js&"
import style0 from "./AddStep2.vue?vue&type=style&index=0&id=c8334b34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8334b34",
  null
  
)

export default component.exports